

import React, { useEffect, useState, useRef } from 'react';
import Cookies from 'js-cookie';
import { renderToString } from 'react-dom/server';
import Modal from '../../components/Modal';
import { Link as DefaultLink } from 'gatsby';
import SEO from '../../components/seo';
import { graphql } from 'gatsby';
import Layout from '../../layouts/DefaultLayout';
import Loading from '../../components/Loading';
import RandomImageGroup from '../../components/RandomImageGroup';
import Loadable from '@loadable/component';
const CheckAvailabilityFormHome = Loadable(() =>
  import('../page-rentals/components/CheckAvailabilityFormHome')
); // code-splitted, on demand loaded component
// import styles from '../../styles/home.module.scss';
import PropertySearchForm from '../../components/PropertySearchForm';
import SearchByDateForm from '../../components/SearchByDateForm';
import MobileSearchForm from './components/MobileSearchForm';
import HeroBackground from '../../components/HeroBackground';
import PropertyDetailsList from '../../components/PropertyDetailsList';
import LazyImage from '../../components/LazyImage';
import BeachHouseCompoundsText from '../../components/BeachHouseCompoundsText';
import { Modal as LastMinuteDealsModal } from '../../components/LastMinuteDeals';

import { getSiteMeta } from '../../util/providers';
// import VideoCover from 'react-video-cover';
import styles from './styles.module.scss';

import { Query, useQuery } from 'react-apollo';
import gql from 'graphql-tag';

const GUEST_REVIEW_LATEST = gql`
  query GuestReservationReviewLatestTop($guestId: Int!) {
    guestReservationReviewLatestTop(where: { guestId: $guestId }) {
      id
      body
      headline
      firstName
      reviewDate
      property {
        name
        sitePage {
          id
      type
      title
      content
      excerpt
      excerpt_extended
      seoDescription
      seoTitle
      slug
      status
      faqEntries {
        id
        sort
        question
        answer
      }
      tags {
        id
        name
        key
      }
      references {
        id
        foreignKey
        type
      }
      featuredImage {
        id
        alt
        caption
        file {
          versions {
            fullUrl
            key
          }
          fullUrl
          mimetype
          # instances {
          #   id
          # }
          small: version(where: { key: "small" }) {
            key
            fullUrl
          }
          tiny: version(where: { key: "tiny" }) {
            key
            fullUrl
          }
          medium: version(where: { key: "medium" }) {
            key
            fullUrl
          }
        }
      }
      featuredImageSecondary {
        id
        alt
        caption
        file {
          fullUrl
          mimetype
          small: version(where: { key: "small" }) {
            fullUrl
          }
          tiny: version(where: { key: "tiny" }) {
            fullUrl
          }
          # instances {
          #   id
          # }
        }
      }
      featuredFileCollection {
        id
        title
        description
        files {
          id
          title
          fullUrl
          mimetype
          versions {
            key
            id
            width
            height
            fullUrl
          }
        }
      }
      featuredImageCollection {
        id
        title
        description
        files {
          id
          title
          fullUrl
          mimetype
          small: version(where: { key: "small" }) {
            key
            fullUrl
          }
          tiny: version(where: { key: "tiny" }) {
            key
            fullUrl
          }
          medium: version(where: { key: "medium" }) {
            key
            fullUrl
          }
          versions {
            key
            id
            width
            height
            fullUrl
          }
        }
      }
              
        }        
      }
    }
  }
`;
// import $ from 'jquery';
import CheaperHotels from '../../images/cheaper-hotels.svg';
import FiveStarAmenities from '../../images/five-star-amenities.svg';
import Over15Years from '../../images/over-15years.svg';
import PetFriendly from '../../images/pet-friendly.svg';
import GenerousDiscounts from '../../images/generous-discounts.svg';
import LargeGroupsWelcome from '../../images/largegroups-welcome.svg';
import OceanToRiver from '../../images/ocean-river.svg';
import '../../styles/slick.scss';
import WithLocation from '../../components/WithLocation';
const Link = WithLocation(({ location, search, children, to, ...rest }) => {

  const [hasMounted, setHasMounted] = React.useState(false);
  React.useEffect(() => {
    setHasMounted(true);
  }, []);
  if (!hasMounted) {
    return null;
  }
  const hrefWithParameters = 'https://www.beachhousesinparadise.com' + (location.location.search ? `${to}${to.indexOf('?') > -1 ? '&' : '?'}${location.location.search.slice(1)}` : to);
  return <a {...rest} href={hrefWithParameters}>{children}</a>;

});

const SITE_ALERT = gql`
  query SiteAlert {
    siteAlert {
      title
      message
      subTitle
      moreMessage
    }
  }
`;

// const VideoCover =
//   typeof window !== 'undefined' &&
//   $(window).width() > 992 &&
//   Loadable(() => import('react-video-cover'));

// let preloadVideo = true;
var connection =
  typeof window !== 'undefined'
    ? navigator.connection ||
    navigator.mozConnection ||
    navigator.webkitConnection ||
    {}
    : {};

const VideoCover = ['slow-2g', '2g', '3g'].includes(connection.effectiveType)
  ? null
  : Loadable(() => import('react-video-cover'));
// if (connection) {
//   if (connection.effectiveType === 'slow-2g') {
//     preloadVideo = false;
//   }
// }

const NextArrow = props => {
  const { className, style, onClick, ...rest } = props;

  return (
    <button
      className={'slick-next'}
      style={{ ...style, display: 'block' }}
      onClick={onClick}
      {...rest}
    >
      <img src="/next.svg" width="23" height="40" alt="Next" />
    </button>
  );
};

const PrevArrow = props => {
  const { className, style, onClick, ...rest } = props;
  return (
    <button
      className={'slick-prev'}
      style={{ ...style, display: 'block' }}
      onClick={onClick}
      {...rest}
    >
      <img src="/previous.svg" alt="Previous" width="23" height="40" />
    </button>
  );
};

var reactSlickSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  arrows: true,
  nextArrow: renderToString(<NextArrow aria-label="Next Promotions" />),
  prevArrow: renderToString(<PrevArrow aria-label="Previous Promotions" />),
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        initialSlide: 1,
      },
    },
  ],
};

const ConditionalForms = ({ location, filteredProperties }) => {
  const [hasMounted, setHasMounted] = React.useState(false);
  const [availabilityModalIsOpen, setAvailabilityModalIsOpen] = useState(
    false
  );
  const params = new URLSearchParams(location?.search);

  //const [dateSearchState, setDateSearchState] = useState(false)
  React.useEffect(() => {
    setHasMounted(true);


  }, []);
  if (!hasMounted) {
    return null;
  }
  const datesearch = true;
  return <>
    {datesearch ? <div className="_d-none _d-lg-block">

      <button
        key="rental-search-button"
        id="rental-search-button"
        onClick={() => {
          setAvailabilityModalIsOpen(true);
        }}
        className={`
          btn btn-secondary text-primary font-weight-bold rounded`}
      >
        <img
          className="mr-1plus"
          style={{
            verticalAlign: 'sub'
          }}
          width="20"
          height="20"
          src="/icon-calendar.svg"
        />Search Dates
      </button>
      <div className="mt-1plus">
        <Link className="text-white " to="/rentals"><u>Advanced Search</u></Link>
      </div>

      <Modal
        isOpen={availabilityModalIsOpen}
        disableFocusTrap={true}
        title={'Availability'}
        onClose={() => setAvailabilityModalIsOpen(false)}
      >
        <CheckAvailabilityFormHome
          loading={false}
          results={23}
          onClose={() => setAvailabilityModalIsOpen(false)}
        />
      </Modal>

    </div> :
      <div><PropertySearchForm
        modalIsOpen={false}
        id="home-page-select-list"
      /><MobileSearchForm id="mobile-form-2" /></div>}</>
}


function ViewMore({ content, maxChars }) {
  const [showMore, setShowMore] = useState(false);

  const toggleShowMore = () => {
    setShowMore(!showMore);
  };

  const truncatedContent = content.slice(0, maxChars);

  return (
    <div>
      {showMore ? content : truncatedContent}
      {content.length > maxChars && (
        <button type="button" className="btn btn-hyperlink d-block pl-0 m-0 text-primary" onClick={toggleShowMore}>
          {showMore ? "View Less" : "View More"}
        </button>
      )}
    </div>
  );
}

const IndexPage = ({ data, pageContext, location, ...props }) => {
  let videoRef = useRef();
  //console.log('location', location);
  const params = new URLSearchParams(location?.search);
  const onlinebooking = true;
  const datesearch = params.get('datesearch') == 'true' ? 'true' : Cookies.get('datesearch');

  const promo = params.get('promo') ? params.get('promo') : Cookies.get('promo');
  const guestId = parseInt(params.get('utm_gid'), 10) || null;

  // Calculate expiration date (30 days from now)
  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + 30);
  const formattedExpirationDate = expirationDate.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  });

  const { data: reviewData, loading: reviewLoading, error: reviewError } = useQuery(
    GUEST_REVIEW_LATEST,
    {
      variables: { guestId },
      skip: !guestId
    }
  );

  const [showPropertyDetails, setShowPropertyDetails] = useState(false);
  const [dateSearchState, setDateSearchState] = useState(datesearch)
  const { sitePage } = data.bhip;
  const videoOptions = {
    src:
      'https://images.beachhousesinparadise.com/videos/bhip-homepage-video-07212025_1.9-bitrate.mp4',
    ref: ref => {
      videoRef = ref;
    },
    autoPlay: true,
    muted: true,
    loop: true,
  };
  const siteMeta = getSiteMeta();
  useEffect(() => {
    $('#promotional-slider').slick(reactSlickSettings);
  }, []);
  const filteredCombos = data.bhip.properties.filter(
    property =>
      property.type === 'COMBO' && property?.sitePage?.status === 'PUBLISHED'
  );

  const filteredProperties = data.bhip.properties.filter(
    property =>
      property?.sitePage?.status === 'PUBLISHED'
  );
  return (
    <>
      <Layout searchbarLabel='Thank you for your Review' hideHeader={true}>


        <SEO
          title={sitePage.seoTitle}
          description={sitePage.seoDescription}
          headTags={sitePage.headTags}
        >
        </SEO>
        <div className="container">

          <div className="text-center my-2">
            <div className="mb-2 text-left">Thank you for your five-star review! To book any of our Beach Houses in Paradise for 45% cheaper than the rate you'll find anywhere else online, click this button:            </div>
            <Link to="/rentals" className="btn btn-secondary text-primary font-weight-bold  ">Search Beach Houses (&amp; Save 45%)</Link>
            <div className="d-md-none mt-2">Scroll down to revisit your kind review:</div>
          </div>
        </div>
        {guestId && (
          <><div className="container">
            {reviewLoading ? (
              <div className="text-center">Loading review...</div>
            ) : reviewError ? (
              <div className="text-center text-danger">Error loading review</div>
            ) : reviewData?.guestReservationReviewLatestTop ? (
              <>
                <div className="row py-2" style={{ backgroundColor: '#F5F5F5' }}>
                  <div className="col-md-3">
                    <div style={{ maxWidth: '250px', textAlign: 'center', margin: 'auto' }}>
                      <Link
                        to={`/${reviewData.guestReservationReviewLatestTop.property.sitePage.slug}`}
                        className="mb-1"
                      >
                        <img src={reviewData.guestReservationReviewLatestTop.property.sitePage.featuredImageCollection
                          .files[0].medium.fullUrl}
                        />
                      </Link>
                    </div>
                    <div className="text-center text-muted">
                      {reviewData.guestReservationReviewLatestTop.property.name}
                    </div>
                  </div>
                  <div className="col-md-9">
                    <div>
                      <div className="d-flex _justify-content-between align-items-center mb-1">
                        <div className="mb-0 mr-2 font-weight-bold">{reviewData.guestReservationReviewLatestTop.firstName}</div>
                        {reviewData.guestReservationReviewLatestTop.reviewDate && (
                          <div>
                            {new Date(reviewData.guestReservationReviewLatestTop.reviewDate).toLocaleDateString('en', {
                              year: 'numeric',
                              month: 'short'
                            })}
                          </div>
                        )}
                      </div>
                      <div className="mb-1">
                        {[1, 2, 3, 4, 5].map(star => (
                          <img key={star} src="/rating-on.svg" width="20" alt="star" className="mr-1" />
                        ))}
                      </div>
                      <div className="mb-1 font-weight-bold">{reviewData.guestReservationReviewLatestTop.headline}</div>
                      <p><i><ViewMore content={reviewData.guestReservationReviewLatestTop.body} maxChars={100}></ViewMore></i></p>
                    </div>
                  </div>
                </div>


              </>
            ) : (
              <div className="text-center">No review found</div>
            )}

          </div>
            <div className="container">
              <div className="mt-2">
                <p>Thank you for your kind words and for choosing Beach Houses in Paradise for your getaway! As a token of our appreciation, we're excited to offer you an exclusive <strong>45% discount</strong> on your next beach house rental — that's nearly half off the price you'll find anywhere else online.</p>
                <p>Click the button below to start planning your perfect beach holiday using your special discount.</p>
                <div className="text-center">
                  <Link to="/rentals" className="btn btn-secondary text-primary font-weight-bold ">Search Beach Houses (&amp; Save 45%)</Link>
                </div>
                <p className="text-center mt-3">Hurry — this flash sale expires in 48 hours!</p>
              </div>
            </div>
          </>)}


      </Layout >
    </>
  );
};

export const query = graphql`
  query GuestReviewLandingPage($slug: String) {
    bhip {
      sitePage(where: { slug: $slug }) {
        ...SitePageData
      }
      properties {
        status
        id
        label
        key
        name
        description
        sleeps
        bedrooms
        bathrooms
        type
        sitePage {
          slug
          status
          featuredImageCollection {
            files {
              tiny: version(where: { key: "tiny" }) {
                fullUrl
              }
              medium: version(where: { key: "medium" }) {
                fullUrl
              }
            }
          }
          # featuredImage {
          #   alt
          #   file {
          #     medium: version(where: { key: "medium" }) {
          #       fullUrl
          #     }
          #     tiny: version(where: { key: "tiny" }) {
          #       fullUrl
          #     }
          #   }
          # }
        }
      }
    }
  }
`;
export default IndexPage;
